import { useRegistryAgency } from "@/contexts/RegistryAgencyContext";
import ResetIcon from "@images/pressList/icon-reload.svg";
import SearchFilterTag from "@PressListContainer/shared/components/SearchFilterTag/SearchFilterTag";
import { useCtgListFilterState } from "@stores/ctgList";

import {
  EDITOR_INFO_CODE,
  STATUS_FILTER,
  StatusCode,
} from "./constants/filterCode.constants";
import * as S from "./CtgListSearchResult.style";

interface SearchType {
  [key: string]: string | undefined;
}

const CtgListSearchResult = () => {
  const [ctgListFilter, setCtgListFilter] = useCtgListFilterState();

  const { RegistryAgencyData } = useRegistryAgency();
  const { search, ctgListDataTotal, status, registryAgency } = ctgListFilter;

  const isSearch =
    (search && !!Object.keys(search).length) ||
    !!status.length ||
    !!registryAgency.length;

  const handleDeleteStatus = (currentCode: string) => {
    const deleteStatusFilter = status.filter(
      (filterCode) => filterCode !== currentCode,
    );

    setCtgListFilter({
      ...ctgListFilter,
      status: deleteStatusFilter,
      page: 1,
    });
  };

  const handleDeleteRegistryAgency = (currentCode: string) => {
    const updatedRegistryAgency = registryAgency.filter(
      (agencyCode) => agencyCode !== currentCode,
    );

    setCtgListFilter({
      ...ctgListFilter,
      registryAgency: updatedRegistryAgency,
      page: 1,
    });
  };

  const handleDeleteSearch = (currentKey: string) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { [currentKey]: currentSearch, ...otherSearch } =
      search as SearchType;

    setCtgListFilter({
      ...ctgListFilter,
      search: {
        ...otherSearch,
      },
      page: 1,
    });
  };

  const handleResetFilter = () => {
    setCtgListFilter({
      ...ctgListFilter,
      search: {},
      status: [],
      registryAgency: [],
    });
  };

  const handleCheckPressIdSearch = (key: string, value: string) => {
    if (key !== "pressId") return value;

    const pressIdValue = value.replace(/#/g, "");

    return `#${pressIdValue}`;
  };

  return (
    <>
      {isSearch && (
        <S.SearchResult>
          <S.SearchResultText>Search Results for</S.SearchResultText>
          {search &&
            Object.entries(search).map(
              ([key, value]) =>
                value && (
                  <SearchFilterTag
                    key={key}
                    type="result"
                    text={handleCheckPressIdSearch(key, value)}
                    isAllInfo={!!(key === "allInfo" || key === "allEditorInfo")}
                    isUserInput
                    code={EDITOR_INFO_CODE[key]}
                    onClickDeleteButton={() => handleDeleteSearch(key)}
                  />
                ),
            )}

          {registryAgency &&
            registryAgency.map((agencyCode) => (
              <SearchFilterTag
                key={agencyCode}
                type="result"
                text={RegistryAgencyData?.[agencyCode] ?? agencyCode}
                isAllInfo={false}
                isTopicType
                onClickDeleteButton={() =>
                  handleDeleteRegistryAgency(agencyCode)
                }
              />
            ))}

          {status &&
            status.map((statusCode) => (
              <SearchFilterTag
                key={statusCode}
                type="result"
                text={STATUS_FILTER[statusCode as StatusCode]}
                isAllInfo={false}
                code={statusCode}
                onClickDeleteButton={() => handleDeleteStatus(statusCode)}
              />
            ))}
          <S.SearchTotalCount>({ctgListDataTotal})</S.SearchTotalCount>
          <S.ResetButton onClick={handleResetFilter}>
            <img src={ResetIcon} width={10} alt="filter reset icon" />
            <S.ResetButtonText>Filter Reset</S.ResetButtonText>
          </S.ResetButton>
        </S.SearchResult>
      )}
    </>
  );
};

export default CtgListSearchResult;
